// ── IP 관리 — 스타일 상수 ──────────────────────────────────────────────────────
// 2026-08-26 디자인 통일: 표·버튼·배지 토큰을 designStandard(직원 관리 기준)로 수렴
import {
  stdTableWrap, stdTable, stdTh, stdTd,
  stdBlackBtn, stdOutlineBtn, stdBadgeActive,
} from '../adminlayout/designStandard';

/* 일반 카드 래퍼 */
export const cardStyle = {
  background: 'var(--bg-card)',
  border: '1px solid var(--border)',
  borderRadius: 8,
  boxShadow: 'none',
  padding: 12,
};

/* 테이블 래퍼 — 표준 표 카드(라운드 8·그림자 없음·검정 머리글 띠) */
export const tableWrapStyle = { ...stdTableWrap };
export const tableStyle = { ...stdTable };
export const thStyle = { ...stdTh };
export const tdStyle = { ...stdTd };

/* IP 상태 + 추가 폼 레이아웃 */
export const statusRowStyle = (isMobile) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: isMobile ? 'stretch' : 'center',
  flexDirection: isMobile ? 'column' : 'row',
  gap: 8,
  marginBottom: 10,
});
export const addGridStyle = (isMobile) => ({
  display: 'grid',
  gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(160px, 1fr))',
  gap: 8,
});

/* 페이지네이션 */
export const paginationWrapStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 10,
  marginTop: 10,
};

/* 폼 입력 */
export const inputStyle = {
  border: '1px solid var(--border)',
  borderRadius: 8,
  padding: '8px 10px',
  fontSize: 13,
  color: 'var(--text)',
  background: 'var(--bg-card)',
  minWidth: 0,
  width: '100%',
};

/* 설명 인라인 편집 */
export const descEditWrapStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  flexWrap: 'nowrap',
};
export const descEditWrapMobileStyle = {
  display: 'grid',
  gridTemplateColumns: '1fr auto',
  gap: 8,
};
export const compactDescInputStyle = {
  border: '1px solid var(--border)',
  borderRadius: 8,
  padding: '5px 8px',
  height: 30,
  minWidth: 140,
  width: '100%',
  lineHeight: 1.2,
  fontSize: 12,
  background: 'var(--bg-card)',
  color: 'var(--text)',
};

/* IP 코드 표시 */
export const ipCodeStyle = {
  display: 'inline-block',
  maxWidth: 320,
  overflowWrap: 'anywhere',
  wordBreak: 'break-all',
};

/* 별칭 행 레이아웃 */
export const aliasRowStyle = {
  display: 'grid',
  gridTemplateColumns: '1.2fr 1fr auto',
  gap: 8,
  alignItems: 'center',
  border: '1px solid var(--border)',
  borderRadius: 10,
  padding: 8,
};
export const aliasActionWrapStyle = { display: 'flex', gap: 6 };
export const aliasInputStyle = {
  border: '1px solid var(--border)',
  borderRadius: 8,
  padding: '8px 10px',
  fontSize: 13,
  background: 'var(--bg-card)',
  color: 'var(--text)',
  minWidth: 0,
  width: '100%',
};

/* 모바일 카드 목록 */
export const mobileCardListStyle = { display: 'grid', gap: 10 };
export const mobileCardStyle = {
  border: '1px solid var(--border)',
  borderRadius: 10,
  padding: 10,
  background: 'var(--bg-card)',
};
export const mobileCardHeadStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 8,
  marginBottom: 8,
};
export const miniBadgeStyle = { ...stdBadgeActive, whiteSpace: 'nowrap' };
export const mobileInfoGridStyle = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: 8,
  marginBottom: 8,
};
export const mobileInfoItemStyle = { display: 'grid', gap: 2, minWidth: 0 };
export const mobileInfoKeyStyle = {
  fontSize: 11,
  color: 'var(--text-muted)',
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: '0.03em',
};
export const mobileCodeStyle = {
  display: 'inline-block',
  overflowWrap: 'anywhere',
  wordBreak: 'break-all',
};
export const mobileActionGridStyle = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: 8,
};

/* 버튼 — 주요=검정 박스 / 보조=흰 외곽선 (designStandard) */
export const btn = { ...stdOutlineBtn };
export const compactBtnStyle = {
  ...btn,
  padding: '5px 8px',
  height: 30,
  fontSize: 12,
  minWidth: 52,
  whiteSpace: 'nowrap',
  lineHeight: 1.1,
};
export const primaryBtn = { ...stdBlackBtn };
export const dangerBtn  = { ...btn, background: '#dc2626', borderColor: '#dc2626', color: '#fff' };
export const doneBtn    = { ...btn, background: 'var(--border)', borderColor: 'var(--border)', color: 'var(--text-sub)', cursor: 'default' };
